import { render, staticRenderFns } from "./Manage-Product-Unit.vue?vue&type=template&id=7bbc3b7e"
import script from "./Manage-Product-Unit.vue?vue&type=script&lang=js"
export * from "./Manage-Product-Unit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports